import instance from 'api';
import { IDynamicTableParams } from '.';

export const exportExcelReport = (data: IDynamicTableParams, baseApiUrl: string = '/api', requestUrl: string) => {
  return instance(true, baseApiUrl)
    .post(requestUrl, data, { responseType: 'blob' })
    .then((response) => response);
};

export const exportPDFReport = (data: IDynamicTableParams, baseApiUrl: string = '/api', requestUrl: string) => {
  return instance(true, baseApiUrl)
    .post(requestUrl, data, { responseType: 'blob' })
    .then((response) => response);
};
